import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <section className="band">
      <div className="wrap">
        <span className="mono key">Error 404</span>
        <h2 style={{ fontSize: "clamp(28px,3.6vw,42px)", margin: "14px 0 14px", maxWidth: "20ch" }}>
          That page has moved or never existed.
        </h2>
        <p className="sub" style={{ maxWidth: "48ch" }}>
          Check the address, or head back to the home page and pick up from there.
        </p>
        <div className="cta">
          <button type="button" className="btn" onClick={() => navigate("/")}>
            Back to home
          </button>
          <button
            type="button"
            className="btn ghost"
            onClick={() => navigate("/", { state: { scrollTo: "contact" } })}
          >
            Contact us
          </button>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
